import api from '@/components/mixins/baseApi';
import mock from '@/mocks/businessCard';

// TODO: переключить на true после готовности API.
// Пока false — все методы уходят в эмуляцию бэка (src/mocks/businessCard.js).
// Реальные запросы делать нельзя: baseAxios при 404 глобально редиректит на page404.
const API_READY = true;

// Слеш в конце адреса — только у /business-card/: без него сервер отвечает 301.
// Остальные маршруты раздела (request, status, collection) зарегистрированы
// на бэке без слеша и со слешем отдают 404, а 404 в baseAxios уводит на page404.
// Проверено на dev.expoup.ru 18.08.2026: 403 = маршрут есть, 404 = маршрута нет.

export default {
  mixins: [api],
  methods: {
    getMyBusinessCard() {
      if (!API_READY) return mock.getMyBusinessCard();
      this.$store.commit('setProgressVal', 1);
      return this.baseAxios({
        method: 'get',
        url: `${this.$store.getters.apiBasePath}/business-card/`,
        onDownloadProgress: (progressEvent) => {
          this.$store.commit('setProgressVal', Math.round(progressEvent.progress * 100));
        },
      })
        .then((data) => {
          this.$store.commit('setProgressVal', 100);
          return data.results;
        })
        .catch((error) => {
          this.$store.commit('setProgressVal', 100);
          throw error;
        });
    },

    saveBusinessCard(formData) {
      if (!API_READY) return mock.saveBusinessCard(formData);
      this.$store.commit('setProgressVal', 1);
      return this.baseAxios({
        method: 'put',
        url: `${this.$store.getters.apiBasePath}/business-card/`,
        data: { data: formData },
      })
        .then((data) => {
          this.$store.commit('setProgressVal', 100);
          return data.results;
        })
        .catch((error) => {
          this.$store.commit('setProgressVal', 100);
          throw error;
        });
    },

    deleteBusinessCard() {
      if (!API_READY) return mock.deleteBusinessCard();
      return this.baseAxios({
        method: 'delete',
        url: `${this.$store.getters.apiBasePath}/business-card/`,
      })
        .then((data) => data)
        .catch((error) => { throw error; });
    },

    getBusinessCardRequests(direction = null, status = null) {
      if (!API_READY) return mock.getBusinessCardRequests(direction, status);
      this.$store.commit('setProgressVal', 1);
      const params = {};
      if (direction) params.direction = direction;
      if (status) params.status = status;
      return this.baseAxios({
        method: 'get',
        url: `${this.$store.getters.apiBasePath}/business-card/request`,
        params,
        onDownloadProgress: (progressEvent) => {
          this.$store.commit('setProgressVal', Math.round(progressEvent.progress * 100));
        },
      })
        .then((data) => {
          this.$store.commit('setProgressVal', 100);
          return data.results;
        })
        .catch((error) => {
          this.$store.commit('setProgressVal', 100);
          throw error;
        });
    },

    sendBusinessCardRequest(toUserId) {
      if (!API_READY) return mock.sendBusinessCardRequest(toUserId);
      return this.baseAxios({
        method: 'post',
        url: `${this.$store.getters.apiBasePath}/business-card/request`,
        data: { to_user_id: toUserId },
      })
        .then((data) => data.results)
        .catch((error) => { throw error; });
    },

    acceptBusinessCardRequest(requestId) {
      if (!API_READY) return mock.acceptBusinessCardRequest(requestId);
      return this.baseAxios({
        method: 'post',
        url: `${this.$store.getters.apiBasePath}/business-card/request/${requestId}/accept`,
      })
        .then((data) => data)
        .catch((error) => { throw error; });
    },

    declineBusinessCardRequest(requestId) {
      if (!API_READY) return mock.declineBusinessCardRequest(requestId);
      return this.baseAxios({
        method: 'post',
        url: `${this.$store.getters.apiBasePath}/business-card/request/${requestId}/decline`,
      })
        .then((data) => data)
        .catch((error) => { throw error; });
    },

    revokeBusinessCardRequest(requestId) {
      if (!API_READY) return mock.revokeBusinessCardRequest(requestId);
      return this.baseAxios({
        method: 'delete',
        url: `${this.$store.getters.apiBasePath}/business-card/request/${requestId}`,
      })
        .then((data) => data)
        .catch((error) => { throw error; });
    },

    getBusinessCardCollection() {
      if (!API_READY) return mock.getBusinessCardCollection();
      this.$store.commit('setProgressVal', 1);
      return this.baseAxios({
        method: 'get',
        url: `${this.$store.getters.apiBasePath}/business-card/collection`,
        onDownloadProgress: (progressEvent) => {
          this.$store.commit('setProgressVal', Math.round(progressEvent.progress * 100));
        },
      })
        .then((data) => {
          this.$store.commit('setProgressVal', 100);
          return data.results;
        })
        .catch((error) => {
          this.$store.commit('setProgressVal', 100);
          throw error;
        });
    },

    getBusinessCardCollectionItem(userId) {
      if (!API_READY) return mock.getBusinessCardCollectionItem(userId);
      this.$store.commit('setProgressVal', 1);
      return this.baseAxios({
        method: 'get',
        url: `${this.$store.getters.apiBasePath}/business-card/collection/${userId}`,
        onDownloadProgress: (progressEvent) => {
          this.$store.commit('setProgressVal', Math.round(progressEvent.progress * 100));
        },
      })
        .then((data) => {
          this.$store.commit('setProgressVal', 100);
          return data.results;
        })
        .catch((error) => {
          this.$store.commit('setProgressVal', 100);
          throw error;
        });
    },

    deleteFromCollection(userId) {
      if (!API_READY) return mock.deleteFromCollection(userId);
      return this.baseAxios({
        method: 'delete',
        url: `${this.$store.getters.apiBasePath}/business-card/collection/${userId}`,
      })
        .then((data) => data)
        .catch((error) => { throw error; });
    },

    getBusinessCardStatus(userId) {
      if (!API_READY) return mock.getBusinessCardStatus(userId);
      return this.baseAxios({
        method: 'get',
        url: `${this.$store.getters.apiBasePath}/business-card/status/${userId}`,
      })
        .then((data) => data.results)
        .catch((error) => { throw error; });
    },
  },
};
